import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { useTranslation } from 'app/lang';
import { accountFullName } from 'app/lib/account/selectors';
import { PERSONAL_DATA_MODAL_PARAM_KEY } from 'app/widgets/PersonalDataModal';

import { PersonalItem } from '../../../PersonalItem';

import dictionary from './UserName.dictionary.json';

import styles from './UserName.module.scss';

export const UserName = () => {
  const { t } = useTranslation();
  const userFullName = useSelector(accountFullName);

  const personalItem = (
    <PersonalItem label={t(dictionary.label)}
                  value={userFullName} />
  );

  if (userFullName?.length) {
    return (
      <div className={styles.root}>
        {personalItem}
      </div>
    );
  }

  return (
    <div className={styles.root}>
      {personalItem}
      <Link className={styles.link}
            to={`?${PERSONAL_DATA_MODAL_PARAM_KEY}`}>
        {t(dictionary.linkTitle)}
      </Link>
    </div>
  );
};
